<template>
  <v-data-table
    :value="selected"
    :headers="headers"
    :items="items"
    :items-per-page="15"
    :search="search"
    :custom-filter="$options.localeIncludes"
    :loading="loading"
    :loading-text="$t('general.loading')"
    show-select
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.lang`]="{ item }">
      <ag-language-text
        v-model="item.lang"
      />
    </template>
    <template v-slot:[`item.defaultVersion`]="{ item }">
      <v-icon v-if="item.defaultVersion" color="accent" large>
        mdi-check
      </v-icon>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        icon
        :to="`/ontime/${item.id}`"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import Helpers from 'src/utils/helpers'
import AgLanguageText from 'src/components/common/AgLanguageText'

export default {
  name: 'VersionList',
  components: {
    AgLanguageText,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Array,
      default: () => ([]),
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('ontime.fields.version.name'),
          value: 'name',
        },
        {
          text: this.$t('general.language'),
          value: 'lang',
          filterable: true,
          align: 'center',
          width: '15%',
        },
        {
          text: this.$t('ontime.fields.version.default'),
          value: 'defaultVersion',
          filterable: false,
          align: 'center',
          width: '15%',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'center',
          width: '15%',
        },
      ]
    },
    items () {
      return this.value.map(version => ({
        id: version.id,
        name: version.name,
        lang: version.lang,
        defaultVersion: !!version.defaultVersion,
      }))
    },
  },
  localeIncludes: Helpers.localeIncludes,
}
</script>
